/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const loopCapacityScopeSchema = z.object({
  loopId: z.int(),
  roleIds: z.array(z.int()),
  skillIds: z.array(z.int()),
});
